import { render, staticRenderFns } from "./airConfig.vue?vue&type=template&id=4b98a0c2&scoped=true"
import script from "./airConfig.vue?vue&type=script&lang=ts"
export * from "./airConfig.vue?vue&type=script&lang=ts"
import style0 from "./airConfig.vue?vue&type=style&index=0&id=4b98a0c2&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98a0c2",
  null
  
)

export default component.exports